// # Reusable animation component
import React, { useEffect, useRef } from 'react';
import './auth_animation.css';

export const LogoFade = ({ src, alt = "Logo" }) => {
  const logoRef = useRef(null);

  useEffect(() => {
    if (logoRef.current) {
      logoRef.current.classList.add('auth_anim_logo-fade-in');
    }
  }, []);

  return (
    <img 
      ref={logoRef}
      src={src}
      alt={alt}
      className="auth_anim_logo-base"
    />
  );
};
